/* CatchFish – product page behaviour: quantity offer (with free-gift line), add-on, delivery estimate. */
(() => {
  function formatMoney(cents, format) {
    const value = Number(cents) / 100;
    const num = (n, dec, th, d) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return dec ? parts[0] + d + parts[1] : parts[0];
    };
    return String(format).replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount_no_decimals': return num(value, 0, ',', '.');
        case 'amount_with_comma_separator': return num(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(value, 2, "'", '.');
        case 'amount_with_space_separator': return num(value, 2, ' ', ',');
        default: return num(value, 2, ',', '.');
      }
    });
  }

  function cfBindForm(sectionId) {
    const form = document.getElementById(`product-form-${sectionId}`);
    if (!form || form.dataset.cfBound) return;
    form.dataset.cfBound = '1';
    const host = form.closest('product-form') || form.parentElement;
    host.addEventListener(
      'submit',
      (e) => {
        if (e.target !== form) return;

        const bundle = document.querySelector(`cf-bundle[data-section="${sectionId}"]`);
        if (bundle) {
          let q = form.querySelector('[name="quantity"]');
          if (!q) {
            q = document.createElement('input');
            q.type = 'hidden';
            q.name = 'quantity';
            form.appendChild(q);
          }
          q.value = bundle.quantity;
        }

        if (form.dataset.cfExtrasDone === '1') return;

        const extras = [];
        const upsell = document.querySelector(`cf-upsell[data-section="${sectionId}"] .cf-upsell__input:checked`);
        if (upsell) extras.push({ id: Number(upsell.value), quantity: 1 });
        if (bundle && bundle.quantity >= 3 && bundle.dataset.giftVariant) {
          extras.push({ id: Number(bundle.dataset.giftVariant), quantity: 1 });
        }
        if (!extras.length) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        const btn = form.querySelector('[type="submit"]');
        if (btn) btn.classList.add('loading');
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: extras }),
        })
          .catch(() => {})
          .finally(() => {
            if (btn) btn.classList.remove('loading');
            if (upsell) {
              upsell.checked = false;
              upsell.dispatchEvent(new Event('change', { bubbles: true }));
            }
            form.dataset.cfExtrasDone = '1';
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit();
            } else {
              form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
            }
            delete form.dataset.cfExtrasDone;
          });
      },
      true
    );
  }

  if (!customElements.get('cf-bundle')) {
    customElements.define(
      'cf-bundle',
      class CfBundle extends HTMLElement {
        connectedCallback() {
          if (this._init) return;
          this._init = true;
          try {
            this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
          } catch (e) {
            this.data = { variants: {} };
          }
          this.format = String(this.data.money_format || '{{amount}}').replace(/<[^>]*>/g, '');
          this.freeMin = parseInt(this.dataset.freeMin || '0', 10);
          this.live = this.dataset.live === 'true';
          this.sectionId = this.dataset.section;

          this.addEventListener('change', (e) => {
            if (e.target.classList && e.target.classList.contains('cf-bundle__radio')) this.select();
          });
          document.addEventListener('change', (e) => {
            const t = e.target;
            if (t && t.name === 'id' && t.closest && t.closest(`#product-form-${this.sectionId}`)) this.update(t.value);
          });
          if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
            subscribe(PUB_SUB_EVENTS.variantChange, (evt) => {
              const v = evt && evt.data && evt.data.variant;
              if (v) this.update(v.id);
              this.syncQuantity();
            });
            subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(() => this.syncQuantity(), 800));
          }
          cfBindForm(this.sectionId);
          this.select();
        }

        get quantity() {
          const c = this.querySelector('.cf-bundle__radio:checked');
          return c ? parseInt(c.value, 10) : 1;
        }

        select() {
          this.querySelectorAll('.cf-bundle__tier').forEach((tier) => {
            const radio = tier.querySelector('.cf-bundle__radio');
            tier.classList.toggle('is-selected', !!(radio && radio.checked));
          });
          this.syncQuantity();
        }

        syncQuantity() {
          const input = document.getElementById(`Quantity-${this.sectionId}`);
          if (input) input.value = this.quantity;
        }

        update(variantId) {
          const price = this.data.variants[String(variantId)];
          if (price == null) return;
          this.querySelectorAll('.cf-bundle__tier').forEach((tier) => {
            const n = parseInt(tier.dataset.qty, 10);
            const d = this.live ? parseInt(tier.dataset.discount || '0', 10) : 0;
            const full = price * n;
            const total = Math.floor((full * (100 - d)) / 100);
            const each = Math.floor(total / n);
            const set = (sel, v) => {
              const el = tier.querySelector(sel);
              if (el) el.textContent = v;
            };
            set('.js-total', formatMoney(total, this.format));
            set('.js-compare', formatMoney(full, this.format));
            set('.js-each', formatMoney(each, this.format));
            const ship = tier.querySelector('.js-ship');
            if (ship) ship.hidden = !(this.freeMin > 0 && total >= this.freeMin);
            const cmp = tier.querySelector('.js-compare');
            if (cmp) cmp.hidden = d === 0;
          });
        }
      }
    );
  }

  if (!customElements.get('cf-upsell')) {
    customElements.define(
      'cf-upsell',
      class CfUpsell extends HTMLElement {
        connectedCallback() {
          if (this._init) return;
          this._init = true;
          const input = this.querySelector('.cf-upsell__input');
          const sync = () => this.classList.toggle('is-on', !!(input && input.checked));
          if (input) input.addEventListener('change', sync);
          sync();
          cfBindForm(this.dataset.section);
        }
      }
    );
  }

  if (!customElements.get('cf-delivery-estimate')) {
    customElements.define(
      'cf-delivery-estimate',
      class CfDeliveryEstimate extends HTMLElement {
        connectedCallback() {
          const min = parseInt(this.dataset.min, 10) || 0;
          const max = Math.max(parseInt(this.dataset.max, 10) || min, min);
          const addBusinessDays = (days) => {
            const d = new Date();
            let left = days;
            while (left > 0) {
              d.setDate(d.getDate() + 1);
              const w = d.getDay();
              if (w !== 0 && w !== 6) left -= 1;
            }
            return d;
          };
          let fmt;
          try {
            fmt = new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
            });
          } catch (e) {
            fmt = { format: (d) => d.toDateString() };
          }
          const out = this.querySelector('.cf-eta__text');
          if (!out) return;
          const tpl = this.dataset.template || 'Get it between {start} and {end}.';
          out.textContent = '';
          tpl.split(/(\{start\}|\{end\})/).forEach((part) => {
            if (part === '{start}' || part === '{end}') {
              const s = document.createElement('strong');
              s.textContent = fmt.format(addBusinessDays(part === '{start}' ? min : max));
              out.appendChild(s);
            } else if (part) {
              out.appendChild(document.createTextNode(part));
            }
          });
        }
      }
    );
  }
})();
